module.exports = __webpack_public_path__ + "img/20.ed80ed0c.svg";